import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonApiService } from '../../../common-api.service';
import { SpeakerService } from '../../../speaker.service';
import { SnackbarService } from '../../../snackbar.service';
import { CommonDropdownService } from '../../../common-dropdown.service';
import { PaginatedDropdown } from '../../../util/paginated-dropdown';
import { DateRange } from '../../../util/date-range';

@Component({
  selector: 'app-daily-job-activity-summary',
  templateUrl: './daily-job-activity-summary.component.html',
  styleUrls: ['./daily-job-activity-summary.component.css']
})
export class DailyJobActivitySummaryComponent implements OnInit, OnDestroy {

  public allJobs: any[] = [];
  public range = new DateRange();

  public city: PaginatedDropdown;

  displayColumns = [
    'date',
    'doctor_count',
    'job_count',
    'units_total',
    'jobs_amount',
  ];
  displayHeaders = [
    'Date',
    'Doctors',
    'Jobs',
    'Units',
    'Amount',
  ];

  constructor(
    public speaker: SpeakerService,
    private api: CommonApiService,
    private snackbar: SnackbarService,
    private dropdownService: CommonDropdownService,
  ) {
    this.city = new PaginatedDropdown(this.api, this.dropdownService, 'area');
  }

  ngOnInit(): void {
    this.speaker.listData = this.allJobs;
    this.city.selectedId = 0;
    this.city.init();
  }

  ngOnDestroy(): void {
    this.city.destroy();
  }

  getReportDetails(data: any) {
    this.speaker.isLoading = true;
    this.api.callRoute('joborder', '/jobsActivitySummary', data).subscribe({
      next: (res) => {
        this.speaker.isLoading = false;
        if (res?.status == false) {
          this.snackbar.info(res.message);
        } else {
          this.allJobs = res;
          this.speaker.listData = this.allJobs;
        }
      },
      error: () => { this.speaker.isLoading = false; }
    });
  }

  generateReport() {
    if (!this.range.validate(this.snackbar)) {
      return;
    }
    const data = {
      start_date: this.range.start,
      end_date: this.range.end,
      city_id: this.city.selectedId,
    };
    this.speaker.listData = [];
    this.getReportDetails(data);
    this.speaker.model = 'joborder';
    this.speaker.displayColumns = this.displayColumns;
    this.speaker.displayHeaders = this.displayHeaders;
  }
}
